import axios from 'axios';
import { API_HOST } from '../consts';

const fetchRaceOptions = async (params) => {
  const res = await axios.get(`${API_HOST}/persons/race`, { params });
  return res.data;
};

export default fetchRaceOptions;
